import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Heart, TrendingUp, BookOpen, Share2 } from "lucide-react";

const STATS = [
  { big: "$1.7B", label: "spent by corporations EVERY YEAR on union-busting consultants & law firms (EPI / LaborLab)" },
  { big: "$26.6M", label: "spent by Amazon alone on outside anti-union consultants in 2025" },
  { big: "70%", label: "of Americans approve of labor unions — near a 60-year high (Gallup)" },
  { big: "+16%", label: "higher median pay for union members vs. non-union workers (BLS)" },
];

export const GrowUnionsCard = () => (
  <div
    id="grow-unions"
    className="relative overflow-hidden rounded-2xl border border-red-500/30 bg-gradient-to-br from-slate-950 via-[#1a0a10] to-red-950 shadow-lg scroll-mt-24"
    data-testid="grow-unions-card"
  >
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_12%_15%,rgba(220,38,38,0.25),transparent_55%)]" />
    <div className="relative p-6 md:p-8">
      <div className="inline-flex items-center gap-1.5 text-red-300 text-xs font-bold uppercase tracking-widest mb-2">
        <TrendingUp className="w-3.5 h-3.5" /> The $1.7 Billion Question
      </div>
      <h3 className="text-xl md:text-2xl font-bold text-white leading-tight mb-2">
        They Spend Billions to Bust Unions. Imagine If We Spent That to Grow Them.
      </h3>
      <p className="text-sm text-slate-300 max-w-3xl mb-5">
        Every dollar spent fighting workers is proof of how powerful an organized worker is.
        The facts say unions should be growing — not getting busted up:
      </p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        {STATS.map((s) => (
          <div key={s.big} className="rounded-xl bg-white/5 border border-white/10 p-3" data-testid={`grow-stat-${s.big.replace(/[^a-zA-Z0-9]/g, "")}`}>
            <div className="text-2xl font-black text-red-300">{s.big}</div>
            <p className="text-[11px] text-slate-300 leading-snug mt-1">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          onClick={() => document.querySelector('[data-testid="support-btn"]')?.click()}
          className="bg-red-600 hover:bg-red-500 text-white font-bold"
          data-testid="grow-unions-support-btn"
        >
          <Heart className="w-4 h-4 mr-2" /> Support LaborEducation.org
        </Button>
        <Link to="/learn">
          <Button variant="outline" className="border-red-400/40 bg-transparent text-red-200 hover:bg-red-500/10 hover:text-white font-bold w-full" data-testid="grow-unions-learn-btn">
            <BookOpen className="w-4 h-4 mr-2" /> Learn Why Unions Matter
          </Button>
        </Link>
        <a href="/grow-unions-share.png" target="_blank" rel="noopener noreferrer">
          <Button variant="outline" className="border-red-400/40 bg-transparent text-red-200 hover:bg-red-500/10 hover:text-white font-bold w-full" data-testid="grow-unions-share-btn">
            <Share2 className="w-4 h-4 mr-2" /> Share These Facts
          </Button>
        </a>
      </div>
    </div>
  </div>
);

export default GrowUnionsCard;
